<template>
  <div class="addWorkFormBox">
    <div>
      <el-form :label-position="topForm" :disabled="true">
        <el-col :span="12">
          <el-form-item label="班次名称" label-width="85px" required>
            <el-input v-model="attendanceName"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="班次负责人" label-width="95px" required>
            <el-select v-model="attendanceCharge" placeholder="请选择负责人" style="width: 150px">
              <el-option label="张三" value="zhangshan"></el-option>
              <el-option label="李四" value="lisi"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-form>
    </div>
    <!-- 循环data中定义的数组 -->
    <div style="margin-bottom: 15px">
      <el-text class="mx-1" style="margin-right: 20px">上下班时间</el-text>
      <el-button @click="dialogClockInVisible = true" type="text">设置打卡时间段</el-button>

      <el-dialog v-model="dialogClockInVisible" title="设置打卡时间段" width="600" >
        <!-- 表单内容 -->
        <el-form :disabled="true">
          <el-row>
            <el-col :span="8">
              <el-form-item label="上班时间" v-model="workTimeForm">
                <el-time-picker placeholder="上班时间" v-model="workTimeForm.workTime" value-format="HH:mm:ss"
                                ></el-time-picker>
              </el-form-item>
            </el-col>
            <el-col :offset="10" :span="6">
              <el-checkbox v-model="workTimeForm.workClockIn">打卡</el-checkbox>
            </el-col>
          </el-row>
        </el-form>
        <el-row>
          <el-col :span="24">
            <el-form-item label="打卡时段" v-model="workTimeForm" >
              <el-text style="font-size: large">上班前{{workTimeForm.workClockInStartTime}}分钟 至 上班后{{workTimeForm.workClockInEndTime}}分钟</el-text>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form>
          <el-row>
            <el-col :span="8">
              <el-form-item label="下班时间" v-model="workTimeForm" >
                <el-time-picker placeholder="下班时间" v-model="workTimeForm.afterWorkTime" value-format="HH:mm:ss"
                                :disabled="true"></el-time-picker>
              </el-form-item>
            </el-col>
            <el-col :offset="1" :span="4">
              <el-tag type="danger" v-if="isTomorrow">次日</el-tag>
            </el-col>
            <el-col :offset="5" :span="6">
              <el-checkbox v-model="workTimeForm.afterWorkClockIn" :disabled="true">打卡</el-checkbox>
            </el-col>
          </el-row>
        </el-form>
        <el-row>
          <el-col :span="24">
            <el-form-item label="打卡时段" v-model="workTimeForm" >
            <el-text style="font-size: large">下班前{{workTimeForm.afterWorkClockInStartTime}}分钟 至 下班后{{workTimeForm.afterWorkClockInEndTime}}分钟</el-text>
            </el-form-item>
          </el-col>
        </el-row>
<!--        <template #footer>
          <div class="dialog-footer">
            <el-button @click="dialogClockInVisible = false">取消</el-button>
            <el-button type="primary" @click="dialogClockInVisible = false">
              确定
            </el-button>
          </div>
        </template>-->
      </el-dialog>
    </div>
    <!-- 表单内容 -->
    <div class="workStyle">
      <el-form>
        <el-row>
          <el-col :span="8">
            <el-form-item label="上班时间" v-model="workTimeForm">
              <el-time-picker placeholder="上班时间" v-model="workTimeForm.workTime" value-format="HH:mm:ss"
                              :disabled="true"
                              ></el-time-picker>
            </el-form-item>
          </el-col>
          <el-col :offset="10" :span="6">
            <el-checkbox v-model="workTimeForm.workClockIn" :disabled="true">打卡</el-checkbox>
          </el-col>
        </el-row>
      </el-form>
      <el-form>
        <el-row>
          <el-col :span="8">
            <el-form-item label="下班时间" v-model="workTimeForm">
              <el-time-picker placeholder="下班时间" v-model="workTimeForm.afterWorkTime" value-format="HH:mm:ss"
                              :disabled="true"
                              ></el-time-picker>
            </el-form-item>
          </el-col>
          <el-col :offset="1" :span="4">
            <el-tag type="danger" v-if="isTomorrow">次日</el-tag>
          </el-col>
          <el-col :offset="5" :span="6">
            <el-checkbox v-model="workTimeForm.afterWorkClockIn" :disabled="true">打卡</el-checkbox>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <el-checkbox v-model="isBreakTime" style="margin-right: 30px;margin-bottom: 10px" :disabled="true">休息时间</el-checkbox>
    <el-form v-if="isBreakTime">
      <el-row>
        <el-col :span="8">
          <el-form-item label="开始时间">
            <el-time-select v-model="breakTimes.startBreakTime" start="00:00" step="00:30"
                            end="23:30" :disabled="true"></el-time-select>
          </el-form-item>
        </el-col>
        <el-col :offset="6" :span="8">
          <el-form-item label="结束时间">
            <el-time-select v-model="breakTimes.endBreakTime" start="00:00" step="00:30"
                            end="23:30" :disabled="true">
            </el-time-select>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>

    <div>
      <el-text class="mx-1" style="margin-right: 30px;font-weight: bold;">弹性打卡</el-text>
    </div>
    <el-form-item v-if="!isNotCountException">
      <el-checkbox v-model="isAllowLeaveEarly" :disabled="true">允许晚到晚走、早到早走</el-checkbox>
    </el-form-item>
    <div v-if="isAllowLeaveEarly">
      <el-form-item label="上班最多可晚到">
        <el-col :span="6">
          <el-input-number v-model="arriveLate" placeholder="选择时间" :min="0" :max="120"
                           controls-position="right" :disabled="true"></el-input-number>
        </el-col>
        <el-col :span="12" class="align-center">
          分钟 上班晚到几分钟，下班须晚走几分钟
        </el-col>
      </el-form-item>
      <el-form-item label="下班最多可提前">
        <el-col :span="6">
          <el-input-number v-model="leaveEarly" placeholder="选择时间" :min="0" :max="120"
                           controls-position="right" :disabled="true"></el-input-number>
        </el-col>
        <el-col :span="16" class="align-center">
          分钟 上班早到几分钟，下班可早走几分钟
        </el-col>
      </el-form-item>
    </div>


    <el-form-item v-if="!isAllowLeaveEarly">
      <el-checkbox v-model="isNotCountException" :disabled="true">晚到、早走几分钟不记为异常</el-checkbox>
    </el-form-item>
    <div v-if="isNotCountException">
      <el-form-item label="上班最多可晚到">
        <el-col :span="6">
          <el-input-number v-model="arriveLate" placeholder="输入时间" :min="0" :max="120"
                           controls-position="right" :disabled="true"></el-input-number>
        </el-col>
        <el-col :span="16" class="align-center">
          分钟，晚到{{ arriveLate }}分钟之内不算迟到
        </el-col>
      </el-form-item>
      <el-form-item label="下班最多可早走">
        <el-col :span="6">
          <el-input-number v-model="leaveEarly" placeholder="输入时间" :min="0" :max="120"
                           controls-position="right" :disabled="true"></el-input-number>
        </el-col>
        <el-col :span="16" class="align-center">
          分钟，早走{{ leaveEarly }}分钟之内不算早退
        </el-col>
      </el-form-item>
    </div>

    <el-form-item>
      <el-checkbox v-model="isTomorrowArriveLate" :disabled="true">下班晚走第二天可晚到</el-checkbox>
    </el-form-item>

    <div v-if="isTomorrowArriveLate">
      <div>
        <el-text class="mx-1" style="margin-right: 30px">计算规则</el-text>
      </div>
      <div class="mb-2 flex items-center text-sm">
        <el-radio-group v-model="isInsideService" class="ml-4">
          <el-radio value="1" size="large" :disabled="true">仅下班的内勤打卡计算为晚走</el-radio>
          <el-radio value="2" size="large" :disabled="true">下班的内勤，外勤打卡均计算为晚走</el-radio>
        </el-radio-group>
      </div>
      <el-form-item label="第一天下班后晚走">
        <el-col :span="6">
          <el-input-number v-model="lateLeaveTimes.firstDayLateLeave" placeholder="输入时间" :min="0" :max="6"
                           controls-position="right" :disabled="true"></el-input-number>
        </el-col>
        <el-col :span="16" class="align-center">
          小时
        </el-col>
      </el-form-item>
      <el-form-item label="第二天上班可晚到">
        <el-col :span="6">
          <el-input-number v-model="lateLeaveTimes.secondDayLateArrive" placeholder="输入时间" :min="0" :max="6"
                           controls-position="right" :disabled="true"></el-input-number>
        </el-col>
        <el-col :span="16" class="align-center">
          小时
        </el-col>
      </el-form-item>
    </div>
    <el-form :label-position="'top'">
      <el-form-item label="班次工时" required>
        <el-text>合计工作时长{{ workDuration }}，记为</el-text>
        <el-input-number v-model="attendanceDays" placeholder="输入时间" style="margin-left: 5px;margin-right: 5px"
                         :min="1"
                         :max="7" controls-position="right" :disabled="true"></el-input-number>
        <el-text> 天出勤</el-text>
      </el-form-item>
    </el-form>
    <el-collapse accordion>
      <el-collapse-item title="更多设置" name="4">
        <el-col :span="24">
          <el-checkbox v-model="isSeriousLate" style="margin-right: 5px" :disabled="true">
            晚到
          </el-checkbox>
          <el-input-number v-model="seriousLateTime" placeholder="输入时间" :min="0" :max="120"
                           controls-position="right" :disabled="true"></el-input-number>
          <el-text> 分钟为严重迟到</el-text>
        </el-col>
        <el-col :span="24">
          <el-checkbox v-model="isAbsenteeismLate" style="margin-right: 5px" :disabled="true">
            晚到
          </el-checkbox>
          <el-input-number v-model="absenteeismLateTime" placeholder="输入时间" :min="0" :max="240"
                           controls-position="right" :disabled="true"></el-input-number>
          <el-text> 分钟为旷工迟到</el-text>
        </el-col>
      </el-collapse-item>
    </el-collapse>
<!--    <el-form-item>
      <el-button v-if="componentParam !== 'edit'" type="primary">立即创建</el-button>
      <el-button v-if="componentParam === 'edit'" type="primary" >保存修改</el-button>
      <el-button @click="cancel">取消</el-button>
    </el-form-item>-->

  </div>
</template>

<script>

export default {
  name: "AttendanceClassesAdd",
  inject: ['$fn'],
  props: {
    componentParam: {
      type: String,
      required: true
    },
    parentData: {
      type: Object,
      default: () => {
        return {}
      }
    },
  },
  data() {
    return {
      topForm: 'top',
      attendanceName: '',
      attendanceCharge: '',


      // 表单绑定数据
      workTimeForm:
          {
            workTime: '09:00:00',
            afterWorkTime: '18:00:00',
            workClockIn: false,
            afterWorkClockIn: false,
            workClockInStartTime: '',
            workClockInEndTime: '',
            afterWorkClockInStartTime: '',
            afterWorkClockInEndTime: ''
          },

      isTomorrow: false,
      //打卡设置对话框
      dialogClockInVisible: false,

      //打卡时间
      checkInTime: '',


      //休息时间段参数
      isBreakTime: false,
      breakTimes:
          {
            startBreakTime: '',
            isStartBreakTomorrow: false,
            endBreakTime: '',
            isEndBreakTomorrow: false
          },

      //允许早到早走
      isAllowLeaveEarly: false,
      leaveEarly: 0,
      arriveLate: 0,

      //晚到早走不记为异常
      isNotCountException: false,

      //下班晚走第二天可晚到

      isTomorrowArriveLate: false,

      //内外勤晚走规则
      lateLeaveTimes:
          {
            firstDayLateLeave: 0,
            secondDayLateArrive: 0
          },
      isInsideService: 0,


      isSeriousLate: false,
      isAbsenteeismLate: false,
      seriousLateTime: '',
      absenteeismLateTime: '',
      //出勤天数
      attendanceDays: 0,

      //班次工时
      oneDayWorkTime: 0,

      days: Array.from({length: 31}, (_, i) => i + 1)

    };
  },
  methods: {
    async getData() {
      let params = {
        id: this.parentData.id
      }
      if (params.id !== undefined) {
        let data = await this.$http("attendanceSettingService.getClassById", params);
        this.workTimeForm.workTime = data.work_time;
        this.workTimeForm.afterWorkTime = data.after_work_time;
        this.workTimeForm.workClockIn = !data.is_work_free_check;
        this.workTimeForm.afterWorkClockIn = !data.is_after_work_free_check;
        this.workTimeForm.workClockInStartTime = data.work_check_before_minutes;
        this.workTimeForm.workClockInEndTime = data.work_check_after_minutes;
        this.workTimeForm.afterWorkClockInStartTime = data.after_work_check_before_minutes;
        this.workTimeForm.afterWorkClockInEndTime = data.after_work_check_after_minutes;
        this.isBreakTime = data.is_break_time;
        this.breakTimes.startBreakTime = data.start_break_time;
        this.breakTimes.isStartBreakTomorrow = data.is_start_break_tomorrow;
        this.breakTimes.endBreakTime = data.end_break_time;
        this.breakTimes.isEndBreakTomorrow = data.is_end_break_tomorrow;
        this.isNotCountException = data.is_not_count_exception;
        this.isAllowLeaveEarly = data.is_allow_leave_early;
        this.leaveEarly = data.leave_early;
        this.arriveLate = data.arrive_late;
        this.isTomorrowArriveLate = data.is_tomorrow_arrive_late;
        this.isInsideService = data.is_inside_service;
        this.lateLeaveTimes.firstDayLateLeave = data.first_day_late_leave;
        this.lateLeaveTimes.secondDayLateArrive = data.second_day_late_arrive;
        this.isSeriousLate = data.is_serious_late;
        this.isAbsenteeismLate = data.is_absenteeism_late;
        this.seriousLateTime = data.serious_late_time;
        this.absenteeismLateTime = data.absenteeism_late_time;
        this.attendanceDays = data.attendance_days;
        this.attendanceName = data.attendance_name;
        this.attendanceCharge = data.attendance_charge;
        this.oneDayWorkTime = data.one_day_work_time;
        this.isTomorrow = data.is_tomorrow;
        if (this.isAllowLeaveEarly){
          this.workTimeForm.workClockInStartTime += this.arriveLate;
          this.workTimeForm.workClockInEndTime += this.leaveEarly;
          this.workTimeForm.afterWorkClockInStartTime += this.arriveLate;
          this.workTimeForm.afterWorkClockInEndTime += this.leaveEarly;
        }
        if (this.isNotCountException){
          this.workTimeForm.workClockInEndTime += this.arriveLate;
          this.workTimeForm.afterWorkClockInStartTime +=this.leaveEarly;
        }
      }

    },
    cancel() {
      this.$fn.closeWindow();
    },
    //获取一天的工作时间
    calculateWorkDuration() {
        const hours = Math.floor(this.oneDayWorkTime / 60);
        const minutes = this.oneDayWorkTime % 60;
        return `${hours}小时${minutes}分钟`;
    },
    breakStartChange() {
      if (this.compareTime(this.workTimeForm.workTime, this.breakTimes.startBreakTime) && this.compareTime(this.workTimeForm.afterWorkTime, this.breakTimes.startBreakTime)
          && this.isTomorrow) {
        this.breakTimes.isStartBreakTomorrow = true;
      } else {
        this.breakTimes.isStartBreakTomorrow = false;
      }
      console.log(this.breakTimes.isStartBreakTomorrow, "start");
      console.log(this.isTomorrow);
    },
    breakEndChange() {
      if (this.compareTime(this.workTimeForm.workTime, this.breakTimes.endBreakTime) && this.compareTime(this.workTimeForm.afterWorkTime, this.breakTimes.endBreakTime)
          && this.isTomorrow) {
        this.breakTimes.isEndBreakTomorrow = true;
      } else {
        this.breakTimes.isEndBreakTomorrow = false;
      }
      console.log(this.breakTimes.isEndBreakTomorrow, "end");
    },
  },
  computed: {
    workDuration: function () {
      return this.calculateWorkDuration();
    }
  },
  //实时获取一周的工作时间
  mounted() {
    this.getData();
  }


}
</script>


<style lang="less" scoped>
@import 'src/global';
</style>
<style scoped>
.addWorkFormBox {
  margin: 20px;
}

h3 {
  margin: 0px 0px 20px 0px;
}

.workStyle {
  padding-top: 10px;
  padding-left: 10px;
  margin-right: 20px;
  border-radius: 10px;
  background: #f6f6f6;
}
</style>
